import { createApp, defineAsyncComponent } from 'vue'
import { loadModules, loadComponents, loadAsyncComponents } from './module-loading'

const vuePlugins = loadModules(import.meta.glob('../plugins/**/global.*.([jt]s)', { eager: true }))
// const vueMixins = loadModules(import.meta.glob('../mixins/**/global.*.([jt]s)', { eager: true }))
// const vueDirectives = loadModules(import.meta.glob('../directives/**/global.*.([jt]s)', { eager: true }))

export const config = ({ name, components, asyncComponents }) => {
  return () => {
    const app = createApp({ name })
    vuePlugins.forEach((plugin) => app.use(plugin))
    // vueMixins.forEach(mixin => app.mixin(mixin))
    // vueDirectives.forEach(directive => app.directive(directive.name, directive.directive))
    if (components) {
      loadComponents(components).forEach(component => app.component(component.name, component))
    }

    if (asyncComponents) {
      loadAsyncComponents(asyncComponents).forEach(([ key, component ]) => app.component(key, defineAsyncComponent(component)))
    }

    return app
  }
}

export const init = (fn) => {
  switch (document.readyState) {
    case 'interactive':
    case 'complete':
      fn()
      break
    default:
      document.addEventListener('DOMContentLoaded', fn)
  }
}
